/*
 * @Author: Teemo Ding
 * @Date: 2021-09-07 17:08:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-07 17:10:12
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/discounts/giftPurchase.ts
 */
import { post } from 'src/tools/server';

export const getGiftPurchaseList = (data, startIndex, batchSize) => {
  return post<any>(
    `/portal/discounts/giftPurchase/${startIndex}/${batchSize}`,
    data || {},
    {},
  );
};

export const saveGiftPurchase = (data, params) => {
  return post<any>(`/portal/discount/giftPurchase`, data || {}, {
    returnWholeData: true,
    handleErrorAsResolve: true,
    ...(params || {}),
  });
};
